<template>
    <div class="reuse-category-wrp" v-if="show">
        <i class="el-icon-warning-outline icon"></i>
        <div class="content">
            <div class="prompt-text">{{ promptText }}</div>
            <div class="descrip">
                {{names.join('>')}}
                <el-button type="link" @click="useIds">点击使用</el-button>
            </div>
        </div>
        <i class="el-icon-close delete-icon" @click="hide"></i>
    </div>
</template>

<script>
// import { getCategoryAndPropertiesMatch } from '@/servers/prod/center'

import {mapGetters} from 'vuex';

export default {
    props: {
        platform: {
            type: String,
            default: ''
        },
        baseItemId: {
            type: [Number, String],
            default: ''
        },
    },
    computed: {
        ...mapGetters(['userInfo'])
    },
    data() {
        return {
            show: true,
            names: [],
            promptText : '上次使用分类',
            categoryObj: {}
        }
    },
    mounted() {
        if(this.baseItemId && this.platform) { 
            // this.promptText = '系统自动预测类目';
            // this.getCategoryPropertiesMatchData();
        } else {
            if (!this.getCategoryIds()) this.show = false;
        }

    },
    methods: {
        hide() {
            this.show = false;
        },
        getCategoryIds() {
            const staffId = this.userInfo.staffId;
            let ids = localStorage.getItem(staffId);
            if (ids) {
                try {
                    ids = JSON.parse(ids);
                } catch(e) {
                    console.error(e);
                }
            }
            if (ids && ids[this.platform] && 
                ids[this.platform].ids && 
                ids[this.platform].ids.length) {
                if (ids[this.platform].names) {
                    this.names = ids[this.platform].names;
                }
                this.categoryObj = ids[this.platform];
                return ids[this.platform];
            }
            return null;
        },
        useIds() {
            let categoryObj = this.categoryObj;
            if (categoryObj && categoryObj.ids) {
                this.$emit('updateIds', categoryObj);
            }
            this.show = false;
        },
        // async getCategoryPropertiesMatchData() {
            
        //     const data = await getCategoryAndPropertiesMatch({
        //         baseItemId: this.baseItemId,
        //         platformType: this.platform === 'alibaba' ? '1688' : this.platform,
        //     })
        //     if(!data?.matchCategoryIds) {
        //         this.promptText = '上次使用分类';
        //         if (!this.getCategoryIds()) this.show = false;
        //         return;
        //     }

        //     const categoryObj = {
        //         ids: data.matchCategoryIds.split(','),
        //         names: data.matchCategoryNames.split(','),
        //     }
        //     this.names = categoryObj.names;
        //     this.categoryObj = categoryObj
        // }
    }
}
</script>
<style lang="scss" scoped>
.reuse-category-wrp{
    margin-top: 6px;
    background-color: #fffbe6;
    border: 1px solid #ffe58f;
    padding: 15px 15px 15px 24px;
    display: flex;
    .icon {
        color: #faad14;
        font-size: 24px;
        margin-right: 5px;
    }
    .content {
        flex: 1 1;
        .prompt-text {
            margin-bottom: 4px;
            color: rgba(0,0,0,.85);
            font-size: 14px;
            font-weight: 600;
        }
    }
    .delete-icon {
        cursor: pointer;
    }
}
</style>